import { render, staticRenderFns } from "./Optionals.vue?vue&type=template&id=5321b560&"
import script from "./Optionals.vue?vue&type=script&lang=ts&"
export * from "./Optionals.vue?vue&type=script&lang=ts&"
import style0 from "./Optionals.vue?vue&type=style&index=0&id=5321b560&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports